const WINDOW_SIZE = 5; // rolling average buffer length
const SCALE = 1; // scroll sensitivity multiplier

let control = {
  state: 'idle', // 'idle' | 'pinch'
  grabWindowXPosition: 0,
  grabWindowYPosition: 0,
  handGrabXPoistion: 0,
  handGrabYPosition: 0,
  bufX: [],
  bufY: [],
  bufIdx: 0,
};

export function handleScrollByGesture(pinch, predictions) {
  if (predictions == undefined || predictions.length == 0) return;

  if (pinch) {
    const ann = predictions[0].annotations;
    const x = ann.indexFinger[3][0];
    const y = ann.indexFinger[3][1];
    if (control.state != 'pinch') {
      // ── First frame of a new pinch: capture grab anchor ──
      control.state = 'pinch';
      control.grabWindowXPosition = window.scrollX;
      control.grabWindowYPosition = window.scrollY;
      control.handGrabXPoistion = x;
      control.handGrabYPosition = y;
      // Pre-fill the buffer so the first average is stable.
      control.bufX = Array(WINDOW_SIZE).fill(x);
      control.bufY = Array(WINDOW_SIZE).fill(y);
      control.bufIdx = 0;
    }
    // ── Rolling average over the last WINDOW_SIZE frames ──
    control.bufX[control.bufIdx] = x;
    control.bufY[control.bufIdx] = y;
    control.bufIdx = (control.bufIdx + 1) % WINDOW_SIZE;

    const avgX = control.bufX.reduce((s, v) => s + v, 0) / WINDOW_SIZE;
    const avgY = control.bufY.reduce((s, v) => s + v, 0) / WINDOW_SIZE;

    const deltaX = (avgX - control.handGrabXPoistion) * SCALE;
    const deltaY = (avgY - control.handGrabYPosition) * SCALE;

    window.scrollTo(control.grabWindowXPosition + deltaX, control.grabWindowYPosition - deltaY);
  } else {
    if (control.state == 'pinch') {
      console.log('unpinch');
    }
    control.state = 'idle';
  }
}
